import dayjs from 'dayjs'
import dayjsDuration from 'dayjs/plugin/duration'

dayjs.extend(dayjsDuration)

export default dayjs
